<div class="rule-body selectable-element">
    <div class="rule-title selectable-element" *ngIf="options.displayTitle">
        <h5>{{ruleViolation.displayText}}</h5>
    </div>
    <div class="rule-description">
        <span [innerHTML]="ruleViolation.reason | safeHtml"> </span>
    </div>
</div>
<div class="rule-footer">
    <div class="rule-comments-wrapper">
        <div class="btn-group btn-group-sm cv-btn-group" role="group">
            <button class="btn btn-sm btn-light cv-btn-light"
                title="View Comments"
                type="button"
                (click)="changeRuleFlow(ruleWorkflowSection.COMMENT_LIST , ruleViolation)" >
                <span>
                    {{(ruleViolation.notes === null) ? '0' :
                    ruleViolation.notes.length}}
                    Comments
                </span>
            </button>
            <button class="btn btn-sm btn-light cv-btn-light add-btn" 
                title="Add Comment"
                type="button"
                [disabled]='!activeActions'
                (click)="changeRuleFlow(ruleWorkflowSection.COMMENT , ruleViolation)">
                <i class="fas fa-plus"></i>
            </button>
        </div>
        <div class="btn-group btn-group-sm cv-btn-group" role="group">
            <button class="btn btn-sm btn-light cv-btn-light"
                title="View Stips"
                type="button"
                (click)="changeRuleFlow(ruleWorkflowSection.STIPS_LIST , ruleViolation)">
                <span>{{(ruleViolation.stips === null) ? '0' :
                    ruleViolation.stips.length}}
                    Stips
                </span>
            </button>
            <button class="btn btn-sm btn-light cv-btn-light add-btn"
                title="Add Stips"
                type="button"
                [disabled]="activeActions === false || ruleViolation.availableStips === null || ruleViolation.availableStips.length === 0"
                (click)="changeRuleFlow(ruleWorkflowSection.STIPS , ruleViolation)">
                <i class="fas fa-plus"></i>
            </button>
        </div>
        <div class="btn-group btn-group-sm cv-btn-group rulesetName" role="group">
            <span class="badge">{{ruleViolation.ruleSetName || ''}}</span>
        </div>
    </div>
</div>